var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03125 2.375H8.96875C9.05208 2.375 9.09375 2.41667 9.09375 2.5V13.5C9.09375 13.5833 9.05208 13.625 8.96875 13.625H8.03125C7.94792 13.625 7.90625 13.5833 7.90625 13.5V2.5C7.90625 2.41667 7.94792 2.375 8.03125 2.375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 7.40625H13.75C13.8333 7.40625 13.875 7.44792 13.875 7.53125V8.46875C13.875 8.55208 13.8333 8.59375 13.75 8.59375H3.25C3.16667 8.59375 3.125 8.55208 3.125 8.46875V7.53125C3.125 7.44792 3.16667 7.40625 3.25 7.40625Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCc);
export default __webpack_public_path__ + "static/media/plus-cc.712ec3e43fa286ab8b5c676c6d09c459.svg";
export { ForwardRef as ReactComponent };